import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import SwitchLanguage from '../UI/SwitchLanguage';
import IconTelegram from '../UI/Icons/IconTelegram';
import IconFacebook from '../UI/Icons/IconFacebook';
import IconLinkedin from '../UI/Icons/IconLinkedin';
import IconYoutube from '../UI/Icons/IconYoutube';
import IconTwitter from '../UI/Icons/IconTwitter';
import IconInstagram from '../UI/Icons/IconInstagram';
import IconReddit from '../UI/Icons/IconReddit';
import IconMedium from '../UI/Icons/IconMedium';
import IconVk from '../UI/Icons/IconVk';
import helpers from '../../helpers/helpers';
import styles from './Footer.module.scss';
import Container from '../UI/Container/Container';
import Logo from '../UI/Logo/Logo';
import CustomLink from '../UI/CustomLink';
import NotificationItem from '../Cabinet/Profile/Notifications/NotificationItem';

const links = [
  { icon: IconVk, link: 'https://vk.com/bit.team' },
  { icon: IconMedium, link: 'https://medium.com/@bit_team' },
  { icon: IconYoutube, link: 'https://www.youtube.com/channel/UC2cHTnl8OhsKGXIiZngn6gA/about?view_as=subscriber' },
  { icon: IconReddit, link: 'https://www.reddit.com/user/bit_team_exchange/?rdt=61469' },
  { icon: IconLinkedin, link: 'https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Ffeed%2F%3Ftrk%3Donboarding-landing' },
  { icon: IconTwitter, link: 'https://twitter.com/BitTeam_group' },
  { icon: IconFacebook, link: 'https://www.facebook.com/pg/BitTeam.group/about/?ref=page_internal' },
  { icon: IconInstagram, link: 'https://instagram.com/bit_team?igshid=1uwiqo4tswass' },
  { icon: IconTelegram, link: 'https://t.me/bitteaminfo' },
];

const Footer = () => {
  const { getTranslationText } = helpers;

  const { language } = useSelector((state) => state.language);

  const telegram = useMemo(() => {
    switch (language) {
      case 'ru-RU':
        return 'https://t.me/spacebot_ru';
      case 'en-US':
        return 'https://t.me/spacebot_en';
      default:
        return 'https://t.me/spacebot_en';
    }
  }, [language]);

  return (
    <footer className={styles.footer}>
      <Container className={styles.footerContainer}>
        <div className={styles.footerLeft}>
          <div className={styles.footerLogoWrap}>
            <CustomLink
              href="/"
              className={styles.footerLogo}
            >
              <Logo />
            </CustomLink>
            <SwitchLanguage />
          </div>
          <div className={styles.footerSocials}>
            <a href="https://t.me/BitteamLive" className={styles.socialBtn}>
              <IconTelegram color="#4579F5" />
            </a>
            {
              links.map((link, index) => (
                <a
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  href={link.link}
                  className={styles.socialBtn}
                >
                  <link.icon color="#4579F5" />
                </a>
              ))
            }
          </div>
        </div>
        <div className={styles.footerRight}>
          <div className={styles.footerMenu}>
            <div className={styles.footerMenuTitle}>
              {getTranslationText('footer.info')}
            </div>
            <a href="https://bit.team/about" className={styles.footerMenuLink}>
              {getTranslationText('footer.about_link')}
            </a>
            <a href="https://bit.team/contacts" className={styles.footerMenuLink}>
              {getTranslationText('footer.contacts_link')}
            </a>
            <CustomLink
              className={styles.footerMenuLink}
              href='/faq/[section]'
              as='/faq/about'
            >
              {getTranslationText('footer.faq_link')}
            </CustomLink>
            <a href="https://bit.team/docs/stock_referrals" className={styles.footerMenuLink}>
              {getTranslationText('footer.referral_link')}
            </a>
          </div>
          <div className={styles.footerMenu}>
            <div className={styles.footerMenuTitle}>
              {getTranslationText('footer.our_prjcts')}
            </div>
            <a href="https://bit.team" className={styles.footerMenuLink}>
              Bit.Team
            </a>
            <a href="https://bit.team/p2p" className={styles.footerMenuLink}>
              P2P
            </a>
            <a href="https://bit.team/btt" className={styles.footerMenuLink}>
              TOKEN
            </a>
            {/*<a href="https://t.me/spacebot_ru" className="nav-column__item">*/}
            {/*  SpaceBot*/}
            {/*</a>*/}
          </div>
          {/*<div>*/}
          {/*<div className={isActions ? 'nav-column collapsed' : 'nav-column'}>*/}
          {/*  <div*/}
          {/*    className="nav-column__title"*/}
          {/*    onClick={() => toggleActions(!isActions)}*/}
          {/*  >*/}
          {/*    Actions*/}
          {/*  </div>*/}
          {/*  <IconArrow color="#9e9ba5" />*/}
          {/* eslint-disable-next-line max-len */}
          {/*  <CustomLink href="/cabinet/gallery/add" as="/cabinet/gallery/add" className="nav-column__item">*/}
          {/*    Add Product*/}
          {/*  </CustomLink>*/}
          {/*</div>*/}
          {/*</div>*/}
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerSubmenu}>
            <a href="https://bit.team/docs/legal/user_agreement" className={styles.footerSubmenuLink}>
              {getTranslationText('footer.user_agr_link')}
            </a>
            <a href="https://bit.team/docs/legal/privacy_policy" className={styles.footerSubmenuLink}>
              {getTranslationText('footer.privacy_link')}
            </a>
            <a href="https://bit.team/docs/legal/btt_agreement" className={styles.footerSubmenuLink}>
              {getTranslationText('footer.btt_link')}
            </a>
            <a href="https://bit.team/docs/legal/aml_policy" className={styles.footerSubmenuLink}>
              {getTranslationText('footer.aml_link')}
            </a>
          </div>
          <div className={styles.footerCopyrights}>
            <span>BIT.TEAM</span>
            {`©. ${new Date().getFullYear()} ${getTranslationText('footer.rights_reserved')}`}
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
